<template>
  <el-dropdown trigger="click" @command="onCommand" @click.stop>
    <el-button
      size="small"
      class="px-2 py-1 bg-profissa-surface border-profissa-glass-border text-profissa-text-main"
      @click.stop
    >
      <el-icon><MoreFilled /></el-icon>
    </el-button>
    <template #dropdown>
      <el-dropdown-menu class="premium-dropdown-menu" @click.stop>
        <el-dropdown-item
          v-for="action in actions"
          :key="action.key"
          :command="action.key"
          :disabled="action.disabled"
          :divided="action.divided"
        >
          <div 
            class="flex items-center gap-2 font-bold py-1 px-2"
            :style="{ color: action.danger ? '#EF4444' : 'var(--text-main)' }"
          >
            <el-icon v-if="action.icon"><component :is="action.icon" /></el-icon>
            <span class="text-sm">{{ action.label }}</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { MoreFilled } from '@element-plus/icons-vue'

defineProps({
  actions: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['action'])

const onCommand = (key) => emit('action', key)
</script>

<style scoped>
/* Force dark context for poppers inside this component if teleported */
:deep(.el-dropdown-menu) {
  background-color: var(--el-bg-color-overlay) !important;
}
</style>
